import moment from "jalali-moment"
import React, { useEffect, useState } from "react"
import SemiCircleChart from "../chart/Chart"
import { useQuery } from "@tanstack/react-query"
import { getFieldHistory } from "../../../../services/api"
import { useParams } from "react-router-dom"



function TimeLine({ showMyPolygon }) {

  const { id } = useParams()
  const newHistoricalFields = useQuery(['historicalFields'], () => getFieldHistory(id, 1))
  const [historicalFields, setHistoricalFields] = useState([])

  useEffect(() => {
    if (newHistoricalFields?.data) {
      setHistoricalFields(newHistoricalFields?.data?.farmHistory)
    }
  }, [newHistoricalFields?.data])

  const totalDays = moment().diff(moment(historicalFields[0]?.createdAt).startOf("days"), "days")

  const betweenDays = historicalFields?.map((item, index) => {
    if (index <= historicalFields?.length - 2) {
      return (
        moment(historicalFields[index + 1]?.createdAt).diff(moment(item?.createdAt).startOf("days"), "days") / totalDays
      )
    } else {
      return (
        moment().diff(moment(item?.createdAt).startOf("days"), "days") / totalDays
      )
    }
  })

  return (
    <div className="absolute flex items-center justify-center w-full cursor-pointer duration-500 -bottom-[220px] hover:-bottom-[175px] max-lg:-bottom-[145px] max-lg:hover:-bottom-[145px] ">
      <div className="button-neo2 !p-[-20px] !rounded-full w-[350px] h-[350px] max-lg:w-[300px] max-lg:h-[300px] flex justify-center items-center z-[999] ">
        <SemiCircleChart betweenDays={betweenDays} historicalFields={historicalFields} showMyPolygon={showMyPolygon} />
      </div>
    </div>
  )
}

export default TimeLine